import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const AddTeamIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 20),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [/*#__PURE__*/jsx("path", {
      d: "M15.74 8.45V19M10.47 13.7H21",
      strokeWidth: "2"
    }), /*#__PURE__*/jsx("path", {
      d: "M5.27 5.38c1.18 0 2.13-.98 2.13-2.2C7.4 1.99 6.45 1 5.27 1s-2.13.98-2.13 2.19c0 1.2.95 2.19 2.13 2.19ZM5.27 12.67H1v-.97c0-1.16.45-2.27 1.25-3.1a4.22 4.22 0 0 1 6.04 0M9.07 1c.56 0 1.1.23 1.5.64a2.22 2.22 0 0 1 0 3.1c-.4.4-.94.64-1.5.64M10.58 7.5c.81.32 1.5.88 2 1.61",
      strokeWidth: "1.5"
    })]
  });
};

export { AddTeamIcon };
//# sourceMappingURL=add-team.js.map
